import { render, staticRenderFns } from "./DevicesCard.vue?vue&type=template&id=40a7bd2e&scoped=true"
import script from "./DevicesCard.vue?vue&type=script&lang=js"
export * from "./DevicesCard.vue?vue&type=script&lang=js"
import style0 from "./DevicesCard.vue?vue&type=style&index=0&id=40a7bd2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7bd2e",
  null
  
)

export default component.exports